export const FILE_INPUT_NAME = 'measurements[dxf]';

export default class Client {
	restUrl: string;

	constructor( restUrl: string ) {
		this.restUrl = restUrl;
	}

	async getProperties( productId, file, shape, edgeFinish: string ): Promise<object> {
		const url = this.restUrl + 'kps/v1/shape_file/get_properties';

		const formData = new FormData();
		formData.append( 'productId', productId );
		formData.append( 'shape', shape );
		formData.append( 'edgeFinish', edgeFinish );

		// The server checks for the dxf extension so make sure we send one with a Blob.
		if ( file instanceof Blob ) {
			formData.append( FILE_INPUT_NAME, file, 'blob.dxf' );
		} else {
			formData.append( FILE_INPUT_NAME, file );
		}

		const response = await fetch( url, { method: 'POST', body: formData } );

		const data = await response.json();
		if (
			! response.ok ||
			data.data && data.data.status && data.data.status === 500
		) {
			throw new Error( data.message );
		}

		if( data.svg_path === "" ) {

			throw new Error( window.measurementSelectorVariables.i18n.uploadingError );
		}

		return data;
	}

}
